import React, { useCallback, useEffect, useState } from 'react';
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import './InvoiceGenerationListPage.css';
import { getUserSession } from '../../utils/auth';
import { calculatePagination } from '../../utils/calculatePagination';
import { makeApiCall } from '../../Api/makeApiCall';
import { Api_Endpoints } from '../../Api/apiEndpoint';
import FilterContainer from '../../components/FilterComponent/FilterContainer';
import { showErrorToast, showSuccessToast } from '../../utils/toastService';
import InvoiceGenerationListPageTable from './InvoiceGenerationListPageTable';

const InvoiceGenerationListPage = () => {
  const [dropDownData, setDropDownData] = useState([]);
  const [filterValue, setFilterValue] = useState({
    searchParam: '',
    productType: '',
    Status: ''
  });

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [filterDrawerVisible, setFilterDrawerVisible] = useState(false);
  const [isRefreshButtonDisabled, setIsRefreshButtonDisabled] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [invoiceList, setInvoiceList] = useState([]);
  const [indexOfLastRecord, setIndexOfLastRecord] = useState(10);
  const [indexOfFirstRecord, setIndexOfFirstRecord] = useState(0);
  const recordsPerPage = 10;
  const [isMobile, setIsMobile] = useState(false);

  const status = [
    { id: 0, label: "Pending" },
    { id: 1, label: "InProgress" },
    { id: 2, label: "Rejected" },
    { id: 3, label: "Refer Back" },
    { id: 4, label: "Completed" },
  ];

  const product = [
    { id: 1, label: "Private Car" },
    { id: 2, label: "Two Wheeler" },
    { id: 3, label: "Commercial" },
    { id: 4, label: "Taxi (1-6)" },
    { id: 5, label: "Threewheeler" },
    { id: 7, label: "Bus PCCV" },
    { id: 8, label: "Threewheeler" },
    { id: 9, label: "Misc D" },
    { id: 10, label: "3 wheeler (GCCV)" },
    { id: 11, label: "3 wheeler(PCCV) 6-17 Seater" },
    { id: 12, label: "Rickshow(PCCV) 3-6 Seater" },
    { id: 13, label: "Ecart Rickshow(GCCV)" },
    { id: 14, label: "Ecart rickshow(PCCV)" }
  ];

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    const pagination = calculatePagination(
      totalRecords,
      recordsPerPage,
      pageNumber
    );
    // setTotalPage(pagination?.totalPages);
    setIndexOfFirstRecord(pagination?.startIndex);
  };

  const searchData = (filteredData) => {
    if (filteredData) {
      setInvoiceList(filteredData);
    }
  };

  const refreshPage = () => {
    GetInvoiceList();
  };

  const handleRefresh = () => {
    setIsRefreshButtonDisabled(true);
    refreshPage();
    
    setTimeout(() => {
      setIsRefreshButtonDisabled(false);
    }, 10000);
  };

  const handleOpenFilterDrawer = () => {
    setFilterDrawerVisible(true);
  };

  const handleCloseFilterDrawer = () => {
    setFilterDrawerVisible(false);
  };

  const resetFilter = () => {
    setFilterValue({
      searchParam: '',
      productType: '',
      Status: ''
    });
    GetInvoiceList();
  };

  const GetInvoiceList = useCallback(() => {
    const data = getUserSession();
    
    const listdata = {
      type: 0,
      status: 1,
      page: currentPage,
      pageSize: 10,
      searchTerm: ''
    };

    if (indexOfFirstRecord !== indexOfLastRecord) {
      makeApiCall(Api_Endpoints.INVOICE_LIST, 'POST', listdata)
        .then((data) => {
          setInvoiceList(data?.result);
          setTotalRecords(data?.data?.totalRecords);
          const pagination = calculatePagination(
            data?.data?.totalRecords,
            recordsPerPage,
            0
          );
          // setTotalPage(pagination?.totalPages);
          setTotalPage(data?.total_pages);
        })
        .catch((error) => {
          console.error(error, "Error fetching invoice list");
        });
    }
  }, [filterValue, indexOfFirstRecord, indexOfLastRecord, currentPage]);

  const handleFilterChange = async (data) => {
    try {
      let postData = {
        type: 0,
        status: data?.status || '',
        startDate: data?.startDate || '',
        endDate: data?.endDate || '',
        searchTerm: data?.search || ''
      };
      
      if (data) {
        const response = await makeApiCall(Api_Endpoints.getClaimedPolicy, 'GET', postData);
        if (response?.status === 200) {
          setInvoiceList(response?.data?.data);
          
          if (response?.data?.data.length === 0) {
            showSuccessToast('No Record Found');
          }
        } else {
          showErrorToast(response?.message);
        }
      }
    } catch (error) {
      console.error('Error occurred while fetching data:', error);
    }
  };

  const handleSearchChange = (event) => {
    setFilterValue(prevData => ({
      ...prevData,
      searchParam: event.target.value
    }));
  };

  const handleReset = () => {
    setFilterValue({
      searchParam: '',
      productType: '',
      Status: ''
    });
    GetInvoiceList();
  };

  const handleDropdownChange = (e, field) => {
    const selectedValue = e.target.value;
    setFilterValue(prevData => ({
      ...prevData,
      [field]: selectedValue
    }));
  };

  const fetchData = async () => {
    const getStatus = await makeApiCall(Api_Endpoints.getStatus, 'GET');
    
    if (getStatus?.status === 200) {
      const dropdownData = [
        {
          label: "status",
          placeholder: 'Select Status',
          options: getStatus.data?.map((data) => ({
            value: data.status_id,
            label: data.name
          }))
        }
      ];
      setDropDownData(dropdownData);
    } else {
      showErrorToast(getStatus?.message);
    }
  };

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);
    setIsMobile(windowWidth <= 768);
    
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [windowWidth]);

  useEffect(() => {
    setIndexOfLastRecord(currentPage * recordsPerPage);
  }, [currentPage, recordsPerPage, totalPage]);

  useEffect(() => {
    GetInvoiceList();
  }, [indexOfLastRecord, indexOfFirstRecord, GetInvoiceList]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="InvoiceGenerationContainer">
      <FilterContainer
        dropdownData={dropDownData}
        handleSearchChange={handleSearchChange}
        handleDropdownChange={handleDropdownChange}
        handleReset={handleReset}
        product={product}
        handleFilterChange={handleFilterChange}
        status={status}
        searchData={searchData}
        ResetList={handleReset}
        type="invoice"
        pageType="invoice"
      />

     

      <div className="flex gap-5">
              <h1 className="text-2xl font-bold mb-4">Invoice List</h1>
              
              <Tippy
                content={
                  isRefreshButtonDisabled ? "wait 10 sec " : "Refresh Files"
                }
                placement="right"
                arrow={true}
                className="rounded-sm text-xs"
              >
                
              </Tippy>
            </div>

      <InvoiceGenerationListPageTable data={invoiceList} refresh={refreshPage} />

      <div className="pagination-container">
        <span className="pagination-info">
          {/* Showing {indexOfFirstRecord + 1} to {Math.min(indexOfFirstRecord + 10, totalRecords)} of {totalRecords} entries */}
          Showing {indexOfFirstRecord + 1} to {indexOfFirstRecord + 10} of{" "}
                {totalRecords} entries
        </span>
        
        <div className="pagination-controls">
          <span className="pagination-info">
            Page {currentPage} of {totalPage}
          </span>
        
          <button
            className="paginationbutton"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Prev
          </button>
          
          <button
            className="paginationbutton"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPage}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvoiceGenerationListPage;